const fontFamily = 'Roboto';

const attachmentFieldStyle = {
  attachmentFieldContainer: {
    width: '100%',
  },

  hiddenInput: {
    display: 'block',
    opacity: 0,
    width: 0,
    height: 0,
    zIndex: -1000,
    overflow: 'hidden',
  },

  titleLabel: {
    fontSize: 18,
    fontWeight: 500,
    lineHeight: '20px',
    fontFamily,
    paddingTop: 10,
    paddingBottom: 8,
  },

  attachmentArea: {
    display: 'flex',
    alignItems: 'flex-start',
    // CON-1929 — several images sit side by side and wrap on narrow screens.
    flexWrap: 'wrap',
    gap: 8,
  },

  uploadButtonContainer: {
    position: 'relative',
  },

  uploadButton: {
    width: 208,
    height: 152,
    background: '#FFFFFF',
    border: '1px dashed #393939',
    boxSizing: 'border-box',
    borderRadius: 4,
    fontFamily,
    textTransform: 'none',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px',

    '&:hover': {
      background: '#F5F5F5',
    },

    '& .svgIcon': {
      width: 32,
      height: 22,
      marginBottom: 4,
    },

    '& .buttonName': {
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '18px',
      color: '#393939',
      padding: '7px 10px',
      width: '100%',
      textAlign: 'center',
    },

    '& .buttonSmallText': {
      fontSize: 10,
      lineHeight: '14px',
      color: '#7A7A7A',
      padding: '0px 10px',
      width: '100%',
      textAlign: 'center',
    },
  },

  // Contact Card styles
  contactCardContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: 208,
    height: 80,
    background: '#F0F7FF',
    border: '1px solid #1976D2',
    borderRadius: 4,
    padding: '12px',
    boxSizing: 'border-box',
  },

  contactCardContent: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    overflow: 'hidden',
  },

  contactCardIcon: {
    fontSize: 40,
    color: '#1976D2',
  },

  contactCardText: {
    overflow: 'hidden',
    '& .MuiTypography-root': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },

  removeButton: {
    color: '#666',
    '&:hover': {
      color: '#f44336',
    },
  },

  // File attached styles
  fileAttachedContainer: {
    display: 'flex',
    alignItems: 'flex-start',
  },

  imagePreviewContainer: {
    width: 208,
    height: 152,
    background: '#FFFFFF',
    border: '1px solid #E0E0E0',
    borderRadius: 4,
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  imagePreview: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },

  fileInfoContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    width: 208,
    height: 60,
    background: '#F5F5F5',
    border: '1px solid #E0E0E0',
    borderRadius: 4,
    padding: '0 12px',
    boxSizing: 'border-box',
  },

  fileIcon: {
    color: '#666',
    fontSize: 24,
  },

  fileName: {
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  deleteButton: {
    display: 'inline-block',
    verticalAlign: 'top',
    padding: 0,
    margin: '0px 0px 0px 15px',
    minWidth: 0,
    minHeight: 0,
    color: '#f44336',
  },

  errorMessage: {
    fontFamily,
    fontSize: 12,
    color: '#f44336',
    paddingTop: 8,
  },
};

export default attachmentFieldStyle;
